// extracted by mini-css-extract-plugin
export default {"container":"InfoTemplate_container__JqlUp","info":"InfoTemplate_info__tYCny","chat":"InfoTemplate_chat__mAHiZ"};